import { render } from "./SortableTables.vue?vue&type=template&id=0a617b9b"
import script from "./SortableTables.vue?vue&type=script&lang=js"
export * from "./SortableTables.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ratul/Code/vue/jourly-admin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__